export default __webpack_public_path__ + "static/O0238-295607014d70e0940af3a1e95a34f5a4.png";